import './TrendingChart.scss';
import { BarChart } from 'plume-ui';
import { BarChartDataItem } from 'plume-ui/dist/utils/charts/chartTypes';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { locationCountAtom } from '../../../../state';
import { Maybe } from '../../../../types';
import { AdjustableComponent } from '../../../../utils/hooks/useClasses';
import { getLegendItems } from '../../containers/fixtures';
import { getHealthSummaryGroups } from '../../services/healthScoreProc';
import { HealthScoreStat } from '../../types';
import ChartLegend from '../ChartLegend/ChartLegend';
import { prepareNetworkHealthData } from '../helpers';

type TrendingProps = {
  typicalData: Maybe<HealthScoreStat>;
  partnerData: Maybe<HealthScoreStat>;
};
type TrendingStyles = {};

const TrendingChart: AdjustableComponent<TrendingProps, TrendingStyles> = ({
  typicalData,
  partnerData,
}) => {
  const { t } = useTranslation();

  const [chartData, setChartData] = useState<BarChartDataItem[]>([]);
  const locationsCount = useRecoilValue(locationCountAtom);

  useEffect(() => {
    if (
      typicalData === undefined ||
      partnerData === undefined ||
      locationsCount === undefined
    ) {
      setChartData([]);
      return;
    }
    setChartData(
      prepareNetworkHealthData(partnerData, typicalData, locationsCount),
    );
  }, [typicalData, partnerData, locationsCount]);

  return (
    <>
      <BarChart
        data={chartData.length !== 0 ? chartData : undefined}
        groups={getHealthSummaryGroups()}
        invertHoverEffect={true}
        config={{
          minHeight: 'auto',
          showPercentageOnTooltip: false,
          showVerticalCartesianGrid: true,
          tooltipTitleRenderer: (
            currentValue: BarChartDataItem,
            nextItem?: BarChartDataItem,
          ) => {
            const titleId = nextItem
              ? 'healthSummary.healthScore.tooltipTitle'
              : 'healthSummary.healthScore.tooltipTitleEdge';
            return t(titleId, {
              low: currentValue.name,
              high: nextItem?.name || '',
            });
          },
          statusVariant: 'legend',
        }}
        stacked={false}
      />
      {chartData.length !== 0 && <ChartLegend {...getLegendItems()} />}
    </>
  );
};

export default memo(TrendingChart);
